import { Box, Paper } from '@mui/material'
import React from 'react'

export const FieldContainer = ({ children }) => {
  return (
    <Paper elevation={0}>
      <Box px={3} py={4}>
        {children}
      </Box>
    </Paper>
  )
}
